import { render, staticRenderFns } from "./ContextmenuContent.vue?vue&type=template&id=05164c34&scoped=true&"
import script from "./ContextmenuContent.vue?vue&type=script&lang=js&"
export * from "./ContextmenuContent.vue?vue&type=script&lang=js&"
import style0 from "./ContextmenuContent.vue?vue&type=style&index=0&id=05164c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05164c34",
  null
  
)

export default component.exports